/**
 * CGate Portal izin kataloğu — backend permissionKey ile birebir eşleşmeli.
 * Tam tablo: src/app/config/permission-catalog.txt
 */

export const P = {
  Analiz: {
    Module: 'Analiz',
    GenelBakis: 'Analiz.GenelBakis',
    BazYilKarsilastirma: 'Analiz.BazYilKarsilastirma',
    GrupSirketleri: 'Analiz.GrupSirketleri',
    EmisyonOzetiGuncelle: 'Analiz.EmisyonOzetiGuncelle',
  },
  GorevPanosu: {
    Module: 'GorevPanosu',
    ProjeYonetimi: 'ProjeYonetimi',
  },
  Yonetim: {
    Module: 'Yönetim',
    Sirketim: 'Yonetim.Sirketim',
    Kullanicilar: 'Yonetim.Kullanicilar',
    Roller: 'Yonetim.Roller',
    Lokasyonlar: 'Yonetim.Lokasyonlar',
    AltSirketler: 'Yonetim.AltSirketler',
    Ekipmanlar: 'Yonetim.Ekipmanlar',
    AtiksuTesisleri: 'Yonetim.Atiksu',
  },
  Hesaplama: {
    Module: 'Hesaplama',
    VeriGirisi: 'Hesaplama.VeriGirisi',
    /**
     * Legacy alias — ürün anlamı TopluVeri ile aynı.
     * VeriYukleme grant'ı olan kullanıcı merkezi Toplu Veri ekranını
     * ve kategori sayfalarındaki upload/status/error yönetimini kullanır.
     * Yeni rol atamalarında Hesaplama.TopluVeri tercih edilir.
     */
    VeriYukleme: 'Hesaplama.VeriYukleme',
    /** Sidebar Toplu Veri Yükleme + job summary/error editor (read/write) */
    TopluVeri: 'Hesaplama.TopluVeri',
    GecmisYillar: 'Hesaplama.GecmisYillar',
  },
  Muhasebe: {
    Module: 'Muhasebe',
    /** Mizan — eski Muhasebe Emisyonu / AccountingEmission */
    Emisyon: 'Muhasebe.Emisyon',
    /** @deprecated Prefer HesapPlani — eski hesap ağacı /tree */
    HesapAgaci: 'Muhasebe.HesapAgaci',
    HesapPlani: 'Muhasebe.HesapPlani',
    Muavin: 'Muhasebe.Muavin',
    EfKutuphanesi: 'Muhasebe.EfKutuphanesi',
    Sonuclar: 'Muhasebe.Sonuclar',
    /** Yardımcı Defterler → Stok sekmesi */
    StokDefteri: 'Muhasebe.StokDefteri',
    /** Yardımcı Defterler → Duran Varlık sekmesi */
    DuranVarlikDefteri: 'Muhasebe.DuranVarlikDefteri',
    Konsolidasyon: 'Muhasebe.Konsolidasyon',
  },
  Raporlar: {
    Module: 'ReportView',
    Emisyon: 'ReportView.Emisyon',
    KategoriEmisyon: 'ReportView.KategoriEmisyon',
  },
  Tedarikci: {
    Module: 'Tedarikci',
  },
  SuAyakIzi: {
    Module: 'Water',
    Genel: 'Water.Genel',
    CekilenSu: 'Water.CekilenSu',
    YagmurSuyu: 'Water.YagmurSuyu',
    AritilanSu: 'Water.AritilanSu',
  },
  UygulamaYonetimi: {
    Module: 'UygulamaYonetimi',
    Sirketler: 'UygulamaYonetimi.Sirketler',
    Entegrasyonlar: 'UygulamaYonetimi.Entegrasyonlar',
  },
  EmisyonFaktorleri: {
    Module: 'EmisyonFaktorleri',
    Sabitler: 'EmisyonFaktorleri.Sabitler',
    Kaynak: 'EmisyonFaktorleri.Kaynak',
    Lojistik: 'EmisyonFaktorleri.Lojistik',
    OtelKonaklama: 'EmisyonFaktorleri.OtelKonaklama',
    EmisyonKaynagiOlusturma: 'EmisyonFaktorleri.EmisyonKaynagiOlusturma',
    KategoriMetotlari: 'EmisyonFaktorleri.KategoriMetotlari',
  },
} as const;

/** Tüm katalog key'leri (Module + Feature) */
export const ALL_PORTAL_PERMISSION_KEYS: readonly string[] = [
  P.Analiz.Module,
  P.Analiz.GenelBakis,
  P.Analiz.BazYilKarsilastirma,
  P.Analiz.GrupSirketleri,
  P.Analiz.EmisyonOzetiGuncelle,
  P.GorevPanosu.Module,
  P.GorevPanosu.ProjeYonetimi,
  P.Yonetim.Module,
  P.Yonetim.Sirketim,
  P.Yonetim.Kullanicilar,
  P.Yonetim.Roller,
  P.Yonetim.Lokasyonlar,
  P.Yonetim.AltSirketler,
  P.Yonetim.Ekipmanlar,
  P.Yonetim.AtiksuTesisleri,
  P.Hesaplama.Module,
  P.Hesaplama.VeriGirisi,
  P.Hesaplama.VeriYukleme,
  P.Hesaplama.TopluVeri,
  P.Hesaplama.GecmisYillar,
  P.Muhasebe.Module,
  P.Muhasebe.Emisyon,
  P.Muhasebe.HesapAgaci,
  P.Muhasebe.HesapPlani,
  P.Muhasebe.Muavin,
  P.Muhasebe.EfKutuphanesi,
  P.Muhasebe.Sonuclar,
  P.Muhasebe.StokDefteri,
  P.Muhasebe.DuranVarlikDefteri,
  P.Muhasebe.Konsolidasyon,
  P.Raporlar.Module,
  P.Raporlar.Emisyon,
  P.Raporlar.KategoriEmisyon,
  P.Tedarikci.Module,
  P.SuAyakIzi.Module,
  P.SuAyakIzi.Genel,
  P.SuAyakIzi.CekilenSu,
  P.SuAyakIzi.YagmurSuyu,
  P.SuAyakIzi.AritilanSu,
  P.UygulamaYonetimi.Module,
  P.UygulamaYonetimi.Sirketler,
  P.UygulamaYonetimi.Entegrasyonlar,
  P.EmisyonFaktorleri.Module,
  P.EmisyonFaktorleri.Sabitler,
  P.EmisyonFaktorleri.Kaynak,
  P.EmisyonFaktorleri.Lojistik,
  P.EmisyonFaktorleri.OtelKonaklama,
  P.EmisyonFaktorleri.EmisyonKaynagiOlusturma,
  P.EmisyonFaktorleri.KategoriMetotlari,
];

/** Login'deki eski düz key → yeni katalog key'leri */
export const LEGACY_FLAT_TO_CATALOG: Readonly<Record<string, readonly string[]>> =
  {
    Dashboard: [P.Analiz.GenelBakis],
    EmissionSummaryUpdate: [P.Analiz.EmisyonOzetiGuncelle],
    EmissionDataUpdate: [P.Hesaplama.VeriGirisi],
    EmissionDataUpload: [P.Hesaplama.VeriYukleme, P.Hesaplama.TopluVeri],
    AccountingEmission: [P.Muhasebe.Emisyon],
    ReportView: [P.Raporlar.Emisyon],
    Water: [P.SuAyakIzi.Module, P.SuAyakIzi.Genel],
  };

/** Sidebar parent grupları için child feature key listeleri */
export const YONETIM_FEATURE_PERMISSIONS = [
  P.Yonetim.Sirketim,
  P.Yonetim.Kullanicilar,
  P.Yonetim.Roller,
  P.Yonetim.Lokasyonlar,
  P.Yonetim.AltSirketler,
  P.Yonetim.Ekipmanlar,
  P.Yonetim.AtiksuTesisleri,
] as const;

/** Ortak lookup API — herhangi bir Yönetim alt modülü read yeterli */
export const YONETIM_SHARED_LOOKUP_PERMISSIONS: readonly string[] = [
  ...YONETIM_FEATURE_PERMISSIONS,
];

export const HESAPLAMA_FEATURE_PERMISSIONS = [
  P.Hesaplama.VeriGirisi,
  P.Hesaplama.VeriYukleme,
  P.Hesaplama.TopluVeri,
  P.Hesaplama.GecmisYillar,
] as const;

/** Toplu veri / import job — TopluVeri + legacy VeriYukleme (aynı ürün yetkisi) */
export const HESAPLAMA_TOPLU_VERI_PERMISSIONS = [
  P.Hesaplama.TopluVeri,
  P.Hesaplama.VeriYukleme,
] as const;

export const MUHASEBE_FEATURE_PERMISSIONS = [
  P.Muhasebe.Emisyon,
  P.Muhasebe.HesapPlani,
  P.Muhasebe.HesapAgaci,
  P.Muhasebe.Muavin,
  P.Muhasebe.EfKutuphanesi,
  P.Muhasebe.Sonuclar,
  P.Muhasebe.StokDefteri,
  P.Muhasebe.DuranVarlikDefteri,
  P.Muhasebe.Konsolidasyon,
] as const;

/** Hesap Planı + legacy Hesap Ağacı (aynı aile) */
export const MUHASEBE_HESAP_PLANI_PERMISSIONS = [
  P.Muhasebe.HesapPlani,
  P.Muhasebe.HesapAgaci,
] as const;

/** Yardımcı Defterler parent (Stok | Duran Varlık) */
export const MUHASEBE_YARDIMCI_DEFTER_PERMISSIONS = [
  P.Muhasebe.StokDefteri,
  P.Muhasebe.DuranVarlikDefteri,
] as const;

export const RAPORLAR_FEATURE_PERMISSIONS = [
  P.Raporlar.Emisyon,
] as const;

export const SU_AYAK_IZI_FEATURE_PERMISSIONS = [
  P.SuAyakIzi.Genel,
  P.SuAyakIzi.CekilenSu,
  P.SuAyakIzi.YagmurSuyu,
  P.SuAyakIzi.AritilanSu,
] as const;

export const UYGULAMA_YONETIMI_FEATURE_PERMISSIONS = [
  P.UygulamaYonetimi.Sirketler,
  P.UygulamaYonetimi.Entegrasyonlar,
] as const;

export const EMISYON_FAKTORLERI_FEATURE_PERMISSIONS = [
  P.EmisyonFaktorleri.Sabitler,
  P.EmisyonFaktorleri.Kaynak,
  P.EmisyonFaktorleri.Lojistik,
  P.EmisyonFaktorleri.OtelKonaklama,
  P.EmisyonFaktorleri.EmisyonKaynagiOlusturma,
  P.EmisyonFaktorleri.KategoriMetotlari,
] as const;

export const ANALIZ_FEATURE_PERMISSIONS = [
  P.Analiz.GenelBakis,
  P.Analiz.BazYilKarsilastirma,
  P.Analiz.GrupSirketleri,
  P.Analiz.EmisyonOzetiGuncelle,
] as const;

export const GOREV_PANOSU_FEATURE_PERMISSIONS = [
  P.GorevPanosu.ProjeYonetimi,
] as const;
